import { render, staticRenderFns } from "./FrontOfLicenseSvg.vue?vue&type=template&id=32b6b045&"
import script from "./FrontOfLicenseSvg.vue?vue&type=script&lang=ts&"
export * from "./FrontOfLicenseSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports